// extracted by mini-css-extract-plugin
export var aboveInput = "_io-0";
export var actionButton = "_io-5";
export var actionButtonContainer = "_io-1";
export var actionIcon = "_io-6";
export var aiInfoContainer = "_io-2";
export var attachmentWrapper = "_io-7";
export var bold = "_io-3";
export var checkIcon = "_io-8";
export var clickingRecipientBar = "_io-11";
export var commentThreadSwitch = "_io-a";
export var draftImage = "_io-b";
export var draftImageContainer = "_io-c";
export var draftImages = "_io-e";
export var editButton = "_io-g";
export var editor = "_io-f";
export var editorContainer = "_io-y";
export var editorErrorTooltipWrapper = "_io-9";
export var headerDivider = "_io-h";
export var icon = "_io-i";
export var info = "_io-j";
export var internal = "_io-n";
export var internalDivider = "_io-k";
export var internalMessage = "_io-l";
export var messageInputCard = "_io-m";
export var messageInputForm = "_io-o";
export var messageInputFormInternal = "_io-p";
export var options = "_io-q";
export var publicMessageCustomer = "_io-s";
export var publicMessageMerchant = "_io-r";
export var removeImageButton = "_io-d";
export var replyButtons = "_io-t";
export var showSignatureButton = "_io-u";
export var spinner = "_io-v";
export var verticalButtonDivider = "_io-4";
export var visibilitySelector = "_io-w";
export var warning = "_io-x";
export var wrappingText = "_io-z";
export var writingInternalNoteTopBorder = "_io-10";